exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".component-beneficial-owner-collection-panel .form-section{background-color:#f7f7f7;padding:20px;margin-top:10px;margin-bottom:10px}", ""]);

// exports
